export { TabRenderer as Renderer } from './components/stateful/TabRenderer'
